/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elegant_Knotty_Okapi_BuildInputs */

const fr_elegant_knotty_okapi_build = /** @type {(inputs: Elegant_Knotty_Okapi_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sur de vouloir supprimer ce PR ?`)
};

/**

* @param {Elegant_Knotty_Okapi_BuildInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const elegant_knotty_okapi_build = /** @type {((inputs?: Elegant_Knotty_Okapi_BuildInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elegant_Knotty_Okapi_BuildInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_elegant_knotty_okapi_build(inputs)
});